import { PropsWithChildren, createContext } from 'react'

interface ComboBoxContextType {
  close: () => void
}

export const ComboBoxContext = createContext<ComboBoxContextType>({
  close: () => {},
})

export const ComboBoxProvider = (props: PropsWithChildren<ComboBoxContextType>) => {
  return <ComboBoxContext.Provider value={props}>{props.children}</ComboBoxContext.Provider>
}
